<div [formGroup]="form">
    <div *ngIf="providerInput">
        <div [ngSwitch]="providerInput.Keyboard" [hidden]="providerInput.IsHidden">
            <label [for]="'input_' + providerInput.Id" class="provider-label"><span *ngIf="providerInput.Required">*
                </span> {{providerInput.Name}}</label>
            <input *ngSwitchCase="'number'" class="provider-field" type="tel"
                [placeholder]="providerInput.Placeholder ? providerInput.Placeholder: '' "
                [id]="'input_' + providerInput.Id" [formControlName]="'input_' + providerInput.Id" autocomplete="on">
            <input *ngSwitchCase="'text'" class="provider-field" type="text"
                [placeholder]="providerInput.Placeholder ? providerInput.Placeholder: ''"
                [id]="'input_' + providerInput.Id" [formControlName]="'input_' + providerInput.Id" autocomplete="on">
            <select *ngSwitchCase="'dropdown'" class="dropdown-field" [id]="'input_' + providerInput.Id"
                [formControlName]="'input_' + providerInput.Id" (change)="onDropdownChange($event)" > 
                <ng-container *ngFor="let option of providerInput.Format">
                    <option  [value]="option.value">{{option.name}} </option>
                </ng-container>
            </select>
        </div>
    </div>
</div>
